import React from 'react';
import Layout from 'layout';

import { authenticationService } from 'auth/authenticationService.js';
import { Link, withRouter } from 'react-router-dom';
// import withRouter  from 'adds/router/withRouter.js';

import Vehiculo from 'pages/permisos/Vehiculo.js'
import Permiso from 'pages/permisos/Permiso.js'
import PermisosHistoricos from 'pages/permisos/PermisosHistoricos.js'


import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import {  
    Box, Paper,
    Typography, Tabs, Tab,
    Grid, Button
    // AppBar

} from '@mui/material';
// import Contribuyente from './Contribuyente';
// import PermisosHistoricos from './PermisosHistoricos';

  
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

class AdministracionVehiculo extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
      vehiculo:null,
      permiso:null,
      // vehiculo:{
      //   vehiculo_uuid:''
      // },
      html:{
        tabs:0,
        is_new:false,
        permiso: false,
        vehiculo: false,
      },
    };

    // this.handleLoad = this.handleLoad.bind(this);
    this.handleTabs = this.handleTabs.bind(this);
    this.handleVehiculo = this.handleVehiculo.bind(this);
    this.handleLoadVehiculo = this.handleLoadVehiculo.bind(this);
    this.handleLoadPermiso = this.handleLoadPermiso.bind(this);
    this.updateVehiculo = this.updateVehiculo.bind(this);
    this.updatePermiso = this.updatePermiso.bind(this);
  }

  componentDidMount(){
    // console.log(this.props)
    this.setState(prevState => ({
      vehiculo: {
          ...prevState.vehiculo,
          vehiculo_uuid:this.props.match.params.vehiculo_uuid,
      },
    }),()=>{
      if(this.props.match.params.vehiculo_uuid !== 'new'){
        this.handleLoadVehiculo(null,true)
      }
      else{
        this.setState(prevState => ({html: {...prevState.html,
          tabs:1,
        }}),()=>{
          this.setState(prevState => ({html: {...prevState.html,
            vehiculo:true
          }}));
        });
      }
    });
  }

  handleLoadVehiculo(vehiculo_uuid = null, reload_permiso = false){

    if (vehiculo_uuid === null) {
      vehiculo_uuid = this.state.vehiculo.vehiculo_uuid
    }

    authenticationService.fetchApi({
        url: '/permisos/vehiculo/'+vehiculo_uuid,
        method: 'GET',
    })
    .then(result => {
      if('vehiculo_uuid' in result){
        this.setState({vehiculo:result},()=>{
          this.setState(prevState => ({html: {...prevState.html,
            vehiculo:true
          }}));
          if(reload_permiso){
            console.log('entra')
            this.handleLoadPermiso();
          }
        });
      }
    })
    .catch(err => {
      
    });
    
  }
  handleLoadPermiso(){
    // console.log('Entra al load de servicio')
    authenticationService.fetchApi({
        url: '/permisos/permiso/?vehiculo_uuid='+this.state.vehiculo.vehiculo_uuid+'&last=true',
        method: 'GET',
    })
    .then(result => {
      if('permiso_uuid' in result){
        this.setState({permiso:result},()=>{
          // console.log(result)
          this.setState(prevState => ({html: {...prevState.html,          
            permiso:true
          }}));
        });
      }
      else{
        this.setState(prevState => ({html: {...prevState.html,          
          permiso:false
        }}),()=>{
          this.setState(prevState => ({html: {...prevState.html,          
            permiso:true
          }}));
        });
      }
    })
    .catch(err => {
    
    });
  }

  handleTabs(event, newValue){
    this.setState(prevState => ({
      html: {
          ...prevState.html,
          tabs:newValue,
      },
    }));
  }

  handleVehiculo(){
    this.setState(prevState => ({
      html: {
          ...prevState.html,
          tabs:1,
      },
    }));
  }

  updateVehiculo(vehiculo, reload=false){
    if(reload){
      this.handleLoadVehiculo();
      this.setState(prevState => ({
        html: {
            ...prevState.html,
            permiso:true,
            vehiculo:true,
        },
      }));
    }
    else{
      this.setState({vehiculo:vehiculo},()=>{
        this.setState(prevState => ({
          html: {
              ...prevState.html,
              permiso:true,
              vehiculo:true,
          },
        }));
      })
    }
  }
  updatePermiso(permiso){
    this.setState({permiso:permiso},()=>{
      this.setState(prevState => ({
        html: {
            ...prevState.html,
            permiso:true,
            vehiculo:true,
        },
      }));
    })
  }

  render() {
    return (
      <Layout title='Vehiculo'>
        { this.state.vehiculo &&
        <Box>

          {!('lista_uuid' in this.props.match.params && this.props.match.params.lista_uuid) &&
          <Box p={1} m={1}>
            <Button startIcon={<ArrowBackIcon/>} component={Link} to='/dashboard/' color='primary'>
              Volver al inicio
            </Button>
          </Box>
          }
          {'lista_uuid' in this.props.match.params && this.props.match.params.lista_uuid &&
            <Button>
              <Button startIcon={<ArrowBackIcon/>} 
                      component={Link} 
                      to={'/permisos/lista_permisos/'+this.props.match.params.lista_uuid} color='primary'>
                Volver a la lista de permisos masiva
              </Button>
            </Button>
          } 
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={this.state.html.tabs} 
                  onChange={this.handleTabs} 
                  aria-label="basic tabs example"
                  indicatorColor="secondary"
                  textColor="inherit"
                  variant="fullWidth"
                  >
              <Tab label="Inicio" {...a11yProps(0)} disabled={this.state.vehiculo.vehiculo_uuid==='new'?true:false} />
              <Tab label="Ficha vehículo" {...a11yProps(1)} />
              <Tab label="Permisos Históricos" {...a11yProps(2)} disabled={this.state.vehiculo.vehiculo_uuid==='new'?true:false}/>
            </Tabs>
          </Box>
          <div role="tabpanel" hidden={this.state.html.tabs !== 0} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            <Paper>
              <Box p={1} m={1}>
                  <Typography variant='h5'>
                      Información básica del vehículo
                  </Typography>
                <Grid container>
                  <Grid item md={3} sm={6}>
                    <Box p={1}>
                      <Typography variant='overline' color='textSecondary'>
                        Patente
                      </Typography>
                      <Box>
                        {this.state.vehiculo.patente}
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item md={3} sm={6}>
                    <Box p={1}>
                      <Typography variant='overline' color='textSecondary'>
                        Marca
                      </Typography>
                      <Box>
                        {this.state.vehiculo.marca}
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item md={3} sm={6}>
                    <Box p={1}>
                      <Typography variant='overline' color='textSecondary'>
                        Modelo
                      </Typography>
                      <Box>
                        {this.state.vehiculo.modelo}
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item md={3} sm={6}>
                    <Box>
                      <Typography variant='overline' color='textSecondary'>
                        Categoría del Vehículo
                      </Typography>
                      <Typography>
                        { this.state.vehiculo?.categoria_tipo===1?"Vehiculo liviano":
                          this.state.vehiculo?.categoria_tipo===3?"Vehiculo Pesado":
                          this.state.vehiculo?.categoria_tipo===2?"Locomoción colectiva":
                          "Hay un error con el vehículo. Por favor contáctanos en el chat para corregirlo"
                          }
                      </Typography>
                    </Box>
                  </Grid>

                </Grid>
              </Box>
              <Box textAlign='right' p={2}>
                <Button onClick={this.handleVehiculo} variant='outlined'>
                  Ver más detalles
                </Button>
              </Box>
            </Paper>
            { this.state.html.permiso &&
            <Box>
              <Permiso  permiso={this.state.permiso}
                        vehiculo={this.state.vehiculo} 
                        edit={true}
                        updatePermiso={this.updatePermiso}/>
            </Box>
            }
          </div>
          <div role="tabpanel" hidden={this.state.html.tabs !== 1} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            <Box>
              {this.state.html.vehiculo &&
              <Vehiculo vehiculo={this.state.vehiculo} updateVehiculo={this.updateVehiculo}/>
              }
            </Box>
          </div>
          <div role="tabpanel" hidden={this.state.html.tabs !== 2} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            { this.state.vehiculo.vehiculo_uuid !=='new' && 
              this.state.vehiculo.vehiculo_uuid !=='' && 
              this.state.html.tabs === 2 &&
            <Box>
              <PermisosHistoricos vehiculo_uuid = {this.state.vehiculo.vehiculo_uuid}
                                  reload={this.handleLoadVehiculo}/>
            </Box>
            }
          </div>
        </Box>
        }
      </Layout>
    );
  }
}

export default withRouter(AdministracionVehiculo);
